export const getValueByIdFromUrl = (key: string, path: string): string => {
  const url = new URL(path);

  const value = url.searchParams.get(key) || '';

  return value;
};
